export default {
  // Navigation
  home: "Home",
  explore: "Explore",
  bookings: "Bookings",
  profile: "Profile",
  dashboard: "Dashboard",
  messages: "Messages",
  earnings: "Earnings",

  // Common
  signOut: "Sign Out",
  save: "Save",
  cancel: "Cancel",
  back: "Back",
  loading: "Loading...",
  submit: "Submit",
  online: "Online",
  offline: "Offline",

  // Home
  welcomeBack: "Welcome back",
  elevateSpace: "Elevate your space with Mouna.",
  discovery: "DISCOVERY",
  curatedServices: "Curated Services",
  allCategories: "All Categories",
  activeAssignments: "Active Assignments",

  // Explore
  findArtisan: "Find your artisan.",
  startingFrom: "Starting from",
  bookNow: "Book Now",
  proVerified: "PRO VERIFIED",

  // Bookings
  myBookings: "My Bookings",
  pending: "pending",
  confirmed: "confirmed",
  completed: "completed",
  help: "Help",

  // Pro Dashboard
  professionalDashboard: "PROFESSIONAL DASHBOARD",
  newLeads: "New Leads",
  accept: "Accept",
  decline: "Decline",
  totalEarnings: "TOTAL EARNINGS",
  leadPricing: "Lead Pricing",
  myPublicProfile: "My Public Profile",
  portfolio: "Portfolio",
  supportTickets: "Support Tickets",

  // Quote Request
  requestQuote: "Request a Quote",
  jobSize: "Job Size",
  describeJob: "Describe Your Job",
  serviceAddress: "Service Address",
  preferredDate: "Preferred Date & Time",
  sendQuoteRequest: "Send Quote Request",
  privateNotes: "Private Notes for Pro (optional)",
  addPhotos: "Add Photos or Videos (optional)",

  // Help
  howCanWeHelp: "How can we help?",
  modifyBooking: "Modify booking",
  cancelBooking: "Cancel booking",
  messageProvider: "Message provider",
  issueWithService: "Issue with service",
  billingIssue: "Billing issue",

  // Auth
  signIn: "Sign In",
  signUp: "Sign Up",
  email: "Email",
  password: "Password",
  noAccount: "No account? Sign up",
  haveAccount: "Have an account? Sign in",

  // Reviews
  leaveReview: "Leave a Review",
  submitReview: "Submit Review",
  respond: "Respond",

  // Support
  contactSupport: "Contact Support",
  myTickets: "My Support Tickets",
  getHelp: "Get Help",
};
